<div class="right-margin">
  <button class="close-icon" (click)="cancel()"><div class="line1"><div class="line2"></div></div></button>
</div>
<div class="body form">
  <h2>Assign Utility</h2>
  <div class="row m-0">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-2">
      <select class="form-control sellerAccInput" [(ngModel)]="state" (change)="changeState()" name="stateId">
        <option [ngValue]="null" [disabled]="true">State</option>
        @for (state of states; track state) {
          <option [ngValue]="state">{{state.name}}</option>
        }
      </select>
    </div>
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
      <select class="form-control sellerAccInput" [(ngModel)]="utility" name="utilityId">
        <option [ngValue]="null" [disabled]="true">Utility</option>
        @for (utility of utilities; track utility) {
          <option [ngValue]="utility">{{utility.name}}</option>
        }
      </select>
    </div>
    @if (this.errorY().showError()) {
      <div class="error-block">{{this.errorY().error}}</div>
    }
    <div class="block-buttons">
      <button type="button" (click)="sendForm()">Finish</button>
    </div>
  </div>
</div>